import { Button, Typography } from "@mui/material";
import React from "react";
import ArrowAnimation from "datalign-module-template/components/arrow-animation";
import { useEasierTheme } from "datalign-themes";

const CollapseButton = ({
  isOpen,
  label,
  HandleCollapse,
}: {
  isOpen: boolean;
  label: string;
  HandleCollapse: (newOpen: boolean) => void;
}) => {
  const theme = useEasierTheme();
  return (
    <Button
      onClick={() => HandleCollapse(!isOpen)}
      color={
        ["nrdata-orig", "FAF-nt"].includes(
          process.env.REACT_APP_STYLING_THEME ?? "",
        )
          ? "inherit"
          : undefined
      }
      sx={{
        display: "flex-inline",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        mb: 1,
        p: 0,
        backgroundColor: ["nrdata-orig", "FAF-nt"].includes(
          process.env.REACT_APP_STYLING_THEME ?? "",
        )
          ? theme?.Colour.SurfaceContainerHigh()
          : undefined,
        textTransform: ["nrdata-orig", "FAF-nt"].includes(
          process.env.REACT_APP_STYLING_THEME ?? "",
        )
          ? "none"
          : undefined,
      }}
    >
      {label && (
        <Typography variant="subtitle2" fontWeight="bold">
          {label}:
        </Typography>
      )}

      <ArrowAnimation isOpen={isOpen} />
    </Button>
  );
};

export default CollapseButton;
